import style from './styles.module.css';

const WarningIconModal = () => {
  return (
    <div className={style.warningIconModal}>
      <i className={`totem-icon totem-icon-warning-solide ${style.warningIcon}`} />
    </div>
  );
};

export default WarningIconModal;
